import { useCallback, useEffect, useState } from 'react'
import { _getVoucherType } from 'state/finance-viilutalous-actions'
import type { VoucherType } from 'ui/ManagerFinance/Settings/VoucherTypeSettings/types'
import { objectToCamelCased } from 'util/changeCase'

function useVoucherType({
	companyUUID,
	databaseSource,
	id,
}: {
	companyUUID: string | undefined
	databaseSource: string | undefined
	id: number | undefined
}) {
	const [voucherType, setVoucherType] = useState<VoucherType | null>(null)

	const [loading, setLoading] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)

	const doQuery = useCallback(async () => {
		if (!companyUUID || !databaseSource || !id) {
			setVoucherType(null)
			setLoading(false)
			setError(null)
			return
		}

		setLoading(true)
		setError(null)
		let data: VoucherType | null = null

		try {
			const response = await _getVoucherType({
				companyUUID,
				databaseSource,
				id,
			})

			if (response && response.ok) {
				const res = await response.json()
				data = objectToCamelCased(res)
			} else {
				throw new Error('Response is not ok.')
			}
		} catch (err) {
			console.error('Error fetching voucher type:', err)
			setError('An error occurred while fetching voucher type: ' + id)
		}
		setVoucherType(data)
		setLoading(false)
	}, [companyUUID, id, databaseSource])

	useEffect(() => {
		doQuery()
	}, [doQuery])

	return {
		voucherType,
		loading,
		error,
		refresh: doQuery,
	}
}

export type useVoucherTypeResult = ReturnType<typeof useVoucherType>

export default useVoucherType
